import { createFileRoute } from '@tanstack/react-router';

import { AdminVenuesPage } from '@/components/admin/sport/venues-page';
import { adminHead } from '@/lib/seo';
import { adminListVenuesFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/venues')({
    component: VenuesRoute,
    head: () => adminHead('אצטדיונים', '/admin/sport/venues'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListVenuesFn({ data: { limit: 50 } }),
});

function VenuesRoute() {
    return <AdminVenuesPage initial={Route.useLoaderData()} />;
}
